import { ReactElement } from 'react';
import { Button, CircularProgress, useTheme } from '@mui/material';

import { styles } from './CustomButtonStyles';

type ButtonType = 'button' | 'submit' | 'reset' | undefined;

interface CustomButtonProps {
  children: ReactElement;
  className?: string;
  endIcon?: ReactElement;
  isDisabled?: boolean;
  isGreenBorder?: boolean;
  isNoBackground?: boolean;
  isOutlinedBtn?: boolean;
  isYellowButton?: boolean;
  onClick: Function;
  showLoader?: boolean;
  type?: ButtonType;
  startIcon?: ReactElement;
  sx?: object;
}

const CustomButton = ({
  children,
  className,
  endIcon,
  isDisabled,
  isGreenBorder,
  isNoBackground,
  isOutlinedBtn,
  isYellowButton,
  onClick,
  type = 'button',
  showLoader,
  startIcon,
  sx,
}: CustomButtonProps) => {
  const theme = useTheme();
  const classes = styles(theme);

  const handleClick = (e: any) => {
    onClick && onClick(e);
  };

  return (
    <Button
      className={className}
      component="button"
      type={type}
      onClick={handleClick}
      sx={{
        ...classes.buttonStyles,
        ...(isYellowButton ? classes.yellowButtonStyles : {}),
        ...(isGreenBorder ? classes.greenBorderStyles : {}),
        ...(isNoBackground ? classes.noBackgroundStyles : {}),
        ...(isOutlinedBtn ? classes.outlinedBtnStyles : {}),
        ...(isDisabled || showLoader ? classes.disabledButton : {}),
        ...sx,
      }}
      disabled={isDisabled || showLoader}
      endIcon={endIcon}
      startIcon={startIcon}
    >
      {!showLoader && children}
      {showLoader && (
        <CircularProgress
          size={15}
          thickness={8}
          sx={classes.btnLoaderStyles}
        />
      )}
    </Button>
  );
};

export default CustomButton;
